import get from 'lodash/get'

export const hasDependencies = project => !!['blocks', 'models'].find(dependency => get(project, `${dependency}.length`, 0) > 0)
